export class AdminHubRegistryRequest  {
    LicenseKey: string;
    SubKey: string;
    Key?: string;
    Value?: string;
    RootString: string;
    ValueKind?: string;
}
